import { HttpClient } from "../../http/HttpClient";
import AccountsRepository from "@/core/customers/repositories/AccountsRepository";
import {
  AccountsResponse,
  AccountsOverviewResponse,
} from "@/core/customers/entities/Accounts";
import { ApiResponse } from "../../api/types/ApiResponse";
import { ApiResponseHandler } from "../../http/services/handleApiResponse/handleApiResponse";
import { getAccountsUrl } from "../../api/accountsEndpoints/accountsEndpoints";
import handleRequestError from "../../http/services/handleRequestError/handleRequestError";
import {
  AccountsMapper,
  ApiAccount,
} from "@/core/customers/mappers/AccountsMapper";

export default class AccountsRepositoryBackend
  implements AccountsRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  async getAccounts(businessKey: string): Promise<AccountsResponse> {
    try {
      const url = getAccountsUrl(businessKey);

      const response = await this.httpClient.get<
        ApiResponse<ApiAccount[]>
      >({
        url,
        withAuth: true,
      });

      const result = ApiResponseHandler.handleResponse<ApiAccount[]>(
        response
      );

      if (result.success && result.data) {
        const apiResponse = {
          code: response.code,
          message: response.message,
          data: result.data,
        };

        return AccountsMapper.toDomainModel(apiResponse);
      }

      throw ApiResponseHandler.createExceptionFromResponse(response);
    } catch (error) {
      throw handleRequestError(error as ApiResponse<unknown>);
    }
  }

  async getAccountsOverview(
    businessKey: string
  ): Promise<AccountsOverviewResponse> {
    // Use the same endpoint as getAccounts
    try {
      const url = getAccountsUrl(businessKey);

      const response = await this.httpClient.get<
        ApiResponse<ApiAccount[]>
      >({
        url,
        withAuth: true,
      });

      const result = ApiResponseHandler.handleResponse<ApiAccount[]>(
        response
      );

      if (result.success && result.data) {
        const apiResponse = {
          code: response.code,
          message: response.message,
          data: result.data,
        };

        return AccountsMapper.toDomainOverview(apiResponse);
      }

      throw ApiResponseHandler.createExceptionFromResponse(response);
    } catch (error) {
      throw handleRequestError(error as ApiResponse<unknown>);
    }
  }
}

